import type { ReactNode } from "react";
import { twJoin } from "tailwind-merge";

const INTEGRATION_STATUS_PRESENTATION_CLASSES = {
  compact: "flex-row gap-space-sm",
  prominent: "flex-col gap-space-md",
} as const;

const INTEGRATION_STATUS_CONTENT_CLASSES = {
  compact: "inline-block max-w-measure-default truncate text-body-emphasis",
  prominent: undefined,
} as const;

export type IntegrationStatusPresentation = keyof typeof INTEGRATION_STATUS_PRESENTATION_CLASSES;

/** Partner mark and status copy with the accepted compact and prominent integration presentations. */
export function IntegrationStatus({
  brandMark,
  children,
  presentation = "compact",
}: {
  brandMark: ReactNode;
  children: ReactNode;
  presentation?: IntegrationStatusPresentation;
}): ReactNode {
  return (
    <span
      className={twJoin("flex items-center text-text-secondary", INTEGRATION_STATUS_PRESENTATION_CLASSES[presentation])}
    >
      {brandMark}
      <span className={INTEGRATION_STATUS_CONTENT_CLASSES[presentation]}>{children}</span>
    </span>
  );
}

/** Single-line integration status content with exact value rhythm and centered copy. */
export function IntegrationStatusLine({ children }: { children: ReactNode }): ReactNode {
  return <span className="flex flex-nowrap gap-space-xs text-center">{children}</span>;
}

/** Secondary line used beneath the primary integration status. */
export function IntegrationStatusFollowUp({ children }: { children: ReactNode }): ReactNode {
  return <span className="mt-space-sm block text-center">{children}</span>;
}
